/** @jsxImportSource @emotion/react */

import { FC, useMemo } from "react";
import { formatPrice } from "../../../../utils/formatNumber";
import { Result } from "../../../../graphql/__GENERATED__/types";
import Row from "../../../../components/Grid/Row";
import { useUIStore } from "../../../../hooks/useUIStore";
import ProviderLogo from "../../../../components/ProviderLogos/ProviderLogo";
import TableColumn from "../../../../components/Details/components/Main/Table/TableColumn";
import { useScreenClass } from "react-grid-system";

interface CostsTableProps {
  selectedResult: Result;
}

const CostsTable: FC<CostsTableProps> = ({ selectedResult }) => {
  const { documentColor } = useUIStore();
  const screenClass = useScreenClass();

  const mobile = useMemo(() => {
    return screenClass === "md" || screenClass === "sm" || screenClass === "xs";
  }, [screenClass]);

  if (!selectedResult) return <></>;

  const tableColumn = [
    {
      label: "Seguradora",
      value: (
        <ProviderLogo
          provider={selectedResult.provider!}
          color={documentColor}
        />
      ),
      hideLabel: true,
    },
    {
      label: "Prêmio",
      value: formatPrice(selectedResult.amounts!.totalPremium),
    },
    {
      label: "Subvenção Estadual*",
      value: selectedResult.amounts?.stateSubvention
        ? ` - ${formatPrice(selectedResult.amounts?.stateSubvention)}`
        : "-",
    },
    {
      label: "Subvenção Federal",
      value: selectedResult.amounts?.federalSubvention
        ? ` - ${formatPrice(selectedResult.amounts?.federalSubvention)}`
        : "-",
    },
    {
      label: "Custo Total",
      value: formatPrice(selectedResult.amounts!.finalPremium),
    },
    {
      label: "Forma de Pagamento",
      value: `${selectedResult.amounts!.maxPayments} X ${formatPrice(
        selectedResult.amounts!.finalPremium! /
          selectedResult.amounts!.maxPayments!
      )}`,
    },
  ];

  return (
    <Row noGutters justify={mobile ? "center" : "start"}>
      {!mobile && (
        <TableColumn
          column={tableColumn}
          mobile={mobile}
          hideValues
          columnsQuantity={1}
        />
      )}
      <TableColumn
        column={tableColumn}
        mobile={mobile}
        hideLabels
        columnsQuantity={1}
      />
    </Row>
  );
};

export default CostsTable;
